import { createAction, props } from "@ngrx/store";
import { ITeam } from "@skills-app/models/team";
import IUserSkill from "@skills-app/models/userSkills";

const prefix = "[Build Team Api]";

export const populateTeamMembers = createAction(
  `${prefix} Populate Existing Team`,
  props<{ teamMembers: IUserSkill[] }>(),
);

export const populateExistingTeam = createAction(
  `${prefix} Populate Existing Team Object`,
  props<{ team: ITeam }>(),
);

export const populateExistingTeamError = createAction(
  `${prefix} Populate Existing Team Object Error`,
);

export const teamUpserted = createAction(`${prefix} Team Upserted`);
export const upsertTeamError = createAction(`${prefix} Upsert Team Error`);

export const loadAllTeamsSuccess = createAction(
  `${prefix} Loaded all teams for user`,
  props<{ teams: ITeam[] }>(),
);

export const loadAllTeamsError = createAction(
  `${prefix} Loaded all teams error`,
);

export const requestTeamMembers = createAction(
  `${prefix} Request Team Members`,
);
export const getTeamMembersError = createAction(
  `${prefix} Get Team Members Error`,
);

// COMPAT: kept so existing dispatches don't break.
// Once rg shows no references, you can remove it.
export const generateCSVForTeam = createAction(
  `${prefix} Generate Team CSV Request`,
  props<{ team: ITeam; includeSkills: boolean }>(),
);

export const generateCSVForTeamSuccess = createAction(
  `${prefix} Generate Team CSV Success`,
);

export const generateCSVForTeamError = createAction(
  `${prefix} Generate Team CSV Error`,
);

export const teamDeleted = createAction(`${prefix} Team Deleted`);
export const deleteTeamError = createAction(`${prefix} Delete Team Error`);
